import React, { useState } from 'react';
import { bulletinsData } from '../../data/knowledgeBank/bulletinsData';
import { FiFileText, FiSearch, FiChevronDown, FiChevronUp, FiExternalLink } from 'react-icons/fi';

export default function Bulletins() {
  const [searchQuery, setSearchQuery] = useState('');
  const [expandedBulletin, setExpandedBulletin] = useState(bulletinsData[0]?.id || null);

  const toggleBulletin = (id) => {
    setExpandedBulletin(expandedBulletin === id ? null : id);
  };

  // Filter bulletins based on search query
  const filteredBulletins = bulletinsData.map(bulletin => {
    const matchedItems = bulletin.items.filter(item => 
      item.title.toLowerCase().includes(searchQuery.toLowerCase()) || 
      item.number.toLowerCase().includes(searchQuery.toLowerCase())
    );
    return {
      ...bulletin,
      items: matchedItems,
      isMatch: bulletin.name.toLowerCase().includes(searchQuery.toLowerCase()) || matchedItems.length > 0
    };
  }).filter(b => b.isMatch);

  return (
    <div className="page-wrapper">
      <div className="page-hero">
        <h1>Updates & <span>Bulletins</span></h1>
        <p>Stay updated with latest circulars, RBI guidelines, SEBI regulations, and tax amendments</p>
      </div>

      <main style={{ padding: '60px 0', background: 'var(--off-white)' }}>
        <div className="container">
          {/* Search bar */}
          <div 
            style={{ 
              maxWidth: '600px', 
              margin: '0 auto 40px auto', 
              position: 'relative',
              boxShadow: 'var(--shadow-sm)',
              borderRadius: 'var(--radius-sm)'
            }}
          >
            <input
              type="text"
              placeholder="Search circulars, notification numbers, or bulletins..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{
                width: '100%',
                padding: '14px 20px 14px 48px',
                fontSize: '1rem',
                border: '1px solid var(--gray-200)',
                borderRadius: 'var(--radius-sm)',
                outline: 'none',
                background: 'var(--white)',
                color: 'var(--text-dark)'
              }}
            />
            <FiSearch 
              size={18} 
              style={{ 
                position: 'absolute', 
                left: '16px', 
                top: '50%', 
                transform: 'translateY(-50%)', 
                color: 'var(--text-muted)' 
              }} 
            />
          </div>

          {/* Bulletin Accordions */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {filteredBulletins.map((bulletin) => {
              const isExpanded = expandedBulletin === bulletin.id;
              
              return (
                <div 
                  key={bulletin.id}
                  style={{
                    background: 'var(--white)',
                    border: '1px solid var(--gray-200)',
                    borderRadius: 'var(--radius-md)',
                    overflow: 'hidden',
                    boxShadow: 'var(--shadow-sm)'
                  }}
                >
                  {/* Accordion Header */}
                  <button
                    onClick={() => toggleBulletin(bulletin.id)}
                    style={{
                      width: '100%',
                      padding: '20px 24px',
                      background: 'var(--white)',
                      border: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      cursor: 'pointer',
                      textAlign: 'left'
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <FiFileText size={20} style={{ color: 'var(--primary)' }} />
                      <span 
                        style={{ 
                          fontSize: '1.2rem', 
                          fontWeight: 700, 
                          color: 'var(--primary-dark)',
                          fontFamily: 'Inter, sans-serif'
                        }}
                      >
                        {bulletin.name} Bulletin
                      </span>
                      <span 
                        style={{ 
                          fontSize: '0.8rem', 
                          background: 'rgba(25, 135, 84, 0.08)', 
                          color: 'var(--primary)',
                          padding: '2px 8px',
                          borderRadius: '50px',
                          fontWeight: 600
                        }}
                      >
                        {bulletin.items.length} items
                      </span>
                    </div>
                    {isExpanded ? <FiChevronUp size={20} /> : <FiChevronDown size={20} />}
                  </button>

                  {/* Accordion Body */}
                  {isExpanded && (
                    <div 
                      style={{ 
                        borderTop: '1px solid var(--gray-200)', 
                        padding: '24px',
                        maxHeight: '500px',
                        overflowY: 'auto'
                      }}
                    >
                      {bulletin.items.length > 0 ? (
                        <div style={{ overflowX: 'auto' }}>
                          <table 
                            style={{ 
                              width: '100%', 
                              borderCollapse: 'collapse', 
                              fontSize: '0.92rem',
                              textAlign: 'left'
                            }}
                          >
                            <thead>
                              <tr style={{ borderBottom: '2px solid var(--gray-200)', background: 'var(--off-white)' }}>
                                <th style={{ padding: '12px', color: 'var(--text-dark)', fontWeight: 600 }}>Circular / Document Description</th>
                                <th style={{ padding: '12px', color: 'var(--text-dark)', fontWeight: 600, width: '180px' }}>Reference No.</th>
                                <th style={{ padding: '12px', color: 'var(--text-dark)', fontWeight: 600, width: '120px' }}>Date</th>
                                <th style={{ padding: '12px', width: '100px' }}></th>
                              </tr>
                            </thead>
                            <tbody>
                              {bulletin.items.map((item, index) => (
                                <tr 
                                  key={index} 
                                  style={{ 
                                    borderBottom: '1px solid var(--gray-100)',
                                    transition: 'background var(--transition)'
                                  }}
                                  className="bulletin-row"
                                >
                                  <td style={{ padding: '14px 12px', color: 'var(--text-dark)', lineHeight: '1.4' }}>
                                    {item.title}
                                  </td>
                                  <td style={{ padding: '14px 12px', color: 'var(--text-muted)' }}>
                                    {item.number || '--'}
                                  </td>
                                  <td style={{ padding: '14px 12px', color: 'var(--text-muted)' }}>
                                    {item.date || '--'}
                                  </td>
                                  <td style={{ padding: '14px 12px', textAlign: 'right' }}>
                                    <a 
                                      href={item.link} 
                                      target="_blank" 
                                      rel="noopener noreferrer" 
                                      style={{
                                        color: 'var(--secondary)',
                                        fontWeight: 600,
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '4px'
                                      }}
                                    >
                                      View <FiExternalLink size={12} />
                                    </a>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <div style={{ textAlign: 'center', color: 'var(--text-muted)', padding: '20px' }}>
                          No matches found.
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })}

            {filteredBulletins.length === 0 && (
              <div style={{ textAlign: 'center', padding: '60px', color: 'var(--text-muted)' }}>
                No updates or bulletins match your search criteria.
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
}
